<template>
  <v-app class="white">

    <v-container fluid>
      <horizontal-stepper
        ref="stepper"
        :steps="stepper"
        :reset="reset"
        @completed-step="completeStep"
        :top-buttons="true"
        @active-step="isStepActive"
        @stepper-finished="ewayPayment"></horizontal-stepper>

        <v-dialog
          v-model="props.dialog.loading"
          persistent
          width="300"
        >
          <v-card
            color="primary"
            dark
          >
            <v-card-text
              class="pt-5 white--text"
            >
              <p>{{ props.loadingMsg }}</p>
              <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="props.dialog.fix"
          persistent
          width="410"
          content-class="warning"
        >
          <v-card
            class="text-left"
          >
            <v-img
              class="red--text darken-2"
              height="150px"
              src="./fix.jpg"
            ></v-img>

            <v-card-title class="px-5 pb-2 headline">
              Oh snap...
            </v-card-title>

            <v-card-text
              class="px-5 pb-0 subtitle-1"
            >
              <div>
                Something went wrong in our registration system. Our engineers are on it. Please try again later. <br>
                <span v-html="props.dialog.fixErrorMessage"></span>
              </div>
            </v-card-text>

            <v-divider light class="my-5"></v-divider>
            <v-card-actions class="px-5 pb-4">
              <v-btn
                color="error"
                rounded
                @click="props.dialog.fix=false; finishEnrolment();"
              >
                <i class="material-icons fs-22">cached</i>
                &nbsp;
                try later
              </v-btn>

            </v-card-actions>
          </v-card>
        </v-dialog>


        <v-dialog
          v-model="props.dialog.paymentError"
          persistent
          width="410"
          content-class="warning"
        >
          <v-card
            class="text-left"
          >
            <v-img
              class="red--text darken-2 text-left"
              height="150px"
              src="./not_paid.jpg"
            ></v-img>

            <v-card-title
              primary-title
              class="px-5 pb-2 headline"
            >
              Payment Error
            </v-card-title>

            <v-card-text
              class="px-5 pb-0 subtitle-1"
            >
              Hmm... there is an something wrong with your payment details.<br>
              {{ props.dialog.paymentErrorMessage }}
            </v-card-text>

            <v-divider class="my-5" light></v-divider>

            <v-card-actions class="px-5 pb-4">
              <v-btn
                color="error"
                rounded outlined
                @click="props.dialog.paymentError=false; "
              >
                <i class="material-icons fs-22">cached</i>
                &nbsp; &nbsp;
                try again
              </v-btn>

            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          persistent
          v-model="props.dialog.finished"
          width="410"
          content-class="warning"
        >
          <v-card
            class="py-5"
          >

            <div class="px-4">
              <i class="icon-tick fs-100 green--text"></i>
              <p class="headline pt-5">
                Thank You
              </p>
            </div>

            <v-card-text
              class="px-5 pb-0 subtitle-1"
            >
              You have successfully enrolled to <b>{{ props.courseName }}</b>. You will receive your booking confirmation email shortly.
            </v-card-text>

            <v-divider light class="my-5"></v-divider>
            <div class="px-5">
              <v-btn
                color="green"
                rounded outlined
                @click="stopTimer();"
              >
                <i class="material-icons fs-22">close</i>
                &nbsp;
                close in {{ props.countDown }}
              </v-btn>
            </div>
          </v-card>
        </v-dialog>
    </v-container>
  </v-app>
</template>

<script>
import HorizontalStepper from 'vue-stepper';
import StepOne from './StepOne.vue';
import StepTwo from './StepTwo.vue';
import StepThree from './StepThree.vue';

import axios from 'axios';
import axcelerate from './axcelerate.js';

const defaultProps = () => {
  return {
    courseName: '',
    countDown: 9,
    timer: null,
    loadingMsg: '',
    accessCode: '',
    dialog: {
      fix: false,
      fixErrorMessage: '',
      paymentError: false,
      paymentErrorMessage: '',
      loading: false,
      finished: false,
    }
  }
}

export default {
  name: 'app',
  components: {
    HorizontalStepper
  },
  data(){
    return {
      props: defaultProps(),
      stepper: [
        {
          icon     : 'icon-open-book',
          name     : 'course',
          title    : 'Course',
          subtitle : 'Select a course',
          component: StepOne,
          completed: false
        },
        {
          icon     : 'icon-profile',
          name     : 'contact',
          title    : 'Contact',
          subtitle : 'Student detail',
          component: StepTwo,
          completed: false
        },
        {
          icon     : 'icon-credit-card',
          name     : 'payment',
          title    : 'Payment',
          subtitle : 'Credit card',
          component: StepThree,
          completed: false
        },

      ],
      activeStep: 0
    }
  },
  mounted() {},
  computed: {},

  methods: {
    completeStep(payload) {
      this.stepper.forEach((step) => {
        if (step.name === payload.name) {
          step.completed = true;
        }
      })
    },
    isStepActive(payload) {
      this.stepper.forEach((step, i) => {
        if (step.name === payload.name) {
          if(step.completed === true) {
            step.completed = false;
          }
        } else if( i == 0 ) {
          this.reset = false;
        }
      })
    },
    paymentOptions() {
      this.props.dialog.paymentOptions = true;
    },
    enrol( paid ) {
      this.props.loadingMsg = "Processing enrolment, please wait...";
      this.props.dialog.loading = true;

      axios.post( axcelerate.enrol( ), {
        data      : this.$store.state,
        accessCode: this.accessCode,
        paid      : paid
      } )
      .then(response => {
        this.props.dialog.loading = false;
        // var session = response.data;

        // If transaction is successful
        if( response.data.success ) {
          this.props.courseName = this.$store.state.course.name;
          this.$store.dispatch( 'setSession', response.data.session );

          this.props.dialog.finished = true;
          this.startTimer();
        } else {
          this.props.dialog.paymentError = true;
          this.props.dialog.paymentErrorMessage = response.data.message;
          this.$root.$emit('canContinue');
        }
        //


      });
    },
    ewayPayment() {
      this.props.loadingMsg = "Connecting to payment gateway...";
      this.props.dialog.loading = true;

      axios.post( axcelerate.ewayURL(), {
        'firstname'   : this.$store.state.contact.givenName,
        'lastname'    : this.$store.state.contact.surname,
        'email'       : this.$store.state.contact.emailAddress,
        'phone'       : this.$store.state.contact.phone,
        'courseID'    : this.$store.state.course.instance,
        'orgID'       : this.$store.state.organisation.id,
        'organisation': this.$store.state.organisation.name,
        'coupon'      : this.$store.state.coupon,
      } )
      .then( response => {
       
        if( response.data !== false ) {
          if( response.data != 'Free' ) {
            this.accessCode = response.data.accessCode;
            window.eCrypt.showModalPayment( { sharedPaymentUrl: response.data.sharedPaymentUrl }, this.ewayCallback );
          } else {
            this.enrol( true );
          }
        } else {
          this.props.dialog.fixErrorMessage = "<b>Error:</b> Training Provider don't have an eWay payment account";
          this.props.dialog.fix = true;
        }

      });
    },
    ewayCallback( result ) {
      if (result == "Complete") {
        this.enrol( true );
      } else if (result == "Error") {
        this.props.dialog.fix = true;
      } else if (result == "Cancel") {
        this.props.dialog.loading = false;
        this.$root.$emit('canContinue');
      }
    },
    startTimer() {
      const self = this;
      this.props.timer = setInterval( function() {
        self.props.countDown -= 1;
        if( self.props.countDown == 0 ) {
          self.stopTimer();
        }
      }, 1000);
    },
    stopTimer() {
      this.props.dialog.finished = false;
      clearInterval(this.props.timer);
      this.props.countDown = 9;
      this.finishEnrolment();
    },
    resetprops() {
      this.props = defaultProps();
    },
    nextStep() {
      var index = this.$refs.stepper.currentStep.index + 1;
      this.$refs.stepper.activateStep(index, true);
    },
    finishEnrolment() {
      this.reset = true;
      this.$store.dispatch( 'softReset' );
      this.resetprops();
    }
  }
}
</script>


<style scoped>

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.pointer {
  cursor: pointer;
}

h1, h2 {
  font-weight: normal;
}

hr {
  background-color: transparent;
  border: none;
  display: block;
  height: inherit;
  margin: 1.5rem 0;
  border-top: dashed 1px;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #0b99b9;
  text-decoration: underline;
}

.text-medium-grey {
  color: #333;
}

.text-light-grey {
    color: #888;
}

.box.formated {
  position: relative;
  padding: 0;
}

.box.formated .heading {
  font-size: 1rem;
  text-transform: capitalize;
  padding: .8rem 1.5rem;
  background-color: #fafafa;
}

.box.formated .content {
  padding: 1rem 2rem;
}

i.top-left {
  position: absolute;
  left: 1.5rem;
  top: 0.8rem;
}

.vertical-separator {
  display: flex;
  justify-content: space-around;
}

.vertical-separator .line {
  border-right: 1px solid #cccccc;
}
</style>
